import { AnalyticsEvent } from './types';

type FetchAnalyticsProps = {
  analyticsEvent: AnalyticsEvent;
  url: string;
};

export async function fetchAnalytics({
  analyticsEvent,
  url,
}: FetchAnalyticsProps) {
  //TODO: Don't test on Cypress
  if (window.Cypress) {
    return;
  }

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(analyticsEvent),
  };

  await fetch(url, options);
}

export default fetchAnalytics;
